module.exports = __webpack_public_path__ + "static/media/instagram.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/instagram.svg
// module id = 499
// module chunks = 0